import React from "react";
import Typical from "react-typical";
import "./Profile.css";
import ScrollService from "../../../utilities/ScrollService";
import resume from "../ASHOKA M.pdf";
function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="https://www.linkedin.com/in/ashoka-m-307984229/">
                <i className="fa fa-linkedin"></i>
              </a>
              <a href="https://www.instagram.com/just_call._.me_reddy/">
                <i className="fa fa-instagram"></i>
              </a>
              <a href="https://github.com/ashokm0603">
                <i className="fa fa-github"></i>
              </a>
            </div>
          </div>

          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'm <span className="highlighted-text">Ashoka.M</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                {" "}
                <Typical
                  steps={[
                    "Frontend Dev😎",
                    5000,
                    "Backend Dev🌐",
                    5000,
                    "Fullstack💻",
                    5000,
                    "Android Dev📱",
                    5000,
                  ]}
                  loop={Infinity}
                />
              </h1>
              <span className="profile-role-tagline">
                Knack of building application or website with back end
                operations.
              </span>
            </span>
          </div>
          <div className="profile-options">
            <button
              className="btn primary-btn"
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              Hire me{" "}
            </button>
            <a href={resume} download={resume}>
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background">
            <img />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
